
<template>
  <div class="wrap-black text-center">
    <div class="container">
      <p class="xs-pb-30">Welcome back! Please enter your information.</p>

      <form method="post" v-on:submit.prevent="login" class="form-pub">
        <div class="form-group">
          <input v-model="credentials.email" name="email" class="form-control" type="email" autofocus placeholder="Your E-mail" autocomplete="off" required="required">
        </div>
        <div class="form-group">
          <input v-model="credentials.password" name="password" class="form-control" type="password" placeholder="Password" autocomplete="off" required="required">
        </div>

        <div v-if="currentUser.errors">
          <div v-for="msg in currentUser.errors" role="alert" class="alert alert-contrast alert-danger alert-dismissible">
            <div class="message">{{msg}}</div>
          </div>
        </div>

        <div class="form-group xs-pt-20">
          <button class="btn-pub btn-pub-primary btn-pub-borderless fixed-width xs-full-width">Log In</button>
        </div>
      </form>
      <p class="xs-pt-30 footer-link">Don't have a account? <router-link to="/signup"><strong>Sign up now</strong></router-link>.</p>
      <p class="footer-link">Forgot your password? <router-link to="/forgot-password"><strong>Reset password</strong></router-link>.</p>
    </div>
  </div>
</template>


<script>
  import { mapState } from 'vuex'

export default {

  created() {
    this.$store.commit(`CLEAR_USER_ERRORS`);
  },

  //{"email": "bob@example.com", "password": "password", "password\_confirmation": "password"}
  methods: {
    login() {
      let user = {
        user: {
          email: this.credentials.email,
          password: this.credentials.password,
        }
      }

      if (this.$route.query.redirect) {
        user.redirect = this.$route.query.redirect;
      }

      this.$store.dispatch('login', user);
    },
  },

  computed: {
    ...mapState([
      'currentUser'
    ])
  },

  data() {
    return {
      credentials: {
        email: null,
        password: null,
      }
    }
  },
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  p { font-size: 18px; line-height: 24px; }
  form { max-width: 460px; margin: 0px auto; }
  .footer-link {font-size:15px;}
  .footer-link a {color:#FFFFFF;}

  @media (max-width: 767px) {
    .wrap-black { padding: 40px 20px; }
  }
</style>



// WEBPACK FOOTER //
// Login.vue?fc02ae88